<template>
  <b-standard-card
    :title="translations.title[lang]"
    :submit-text="{ el: 'Αποθήκευση', en: 'Save', it: 'Salva' }"
    :loading="loading"
    class="mt-5"
    height="auto"
    :error-message="errorMessage"
    :disabled="!!errorMessage"
    @submit="submitData"
  >
    {{ translations[`description_${storeMode}`][lang] }}
    <p class="">
      <i>{{ translations.description2[lang] }}</i>
    </p>
    <v-row class="flex-row">
      <v-col md="6">
        <b-text-field
          :label="translations.min[lang]"
          type="number"
          v-model="limits.min_amount_limit"
          @blur="validate"
        ></b-text-field>
      </v-col>
      <v-col md="6">
        <b-text-field
          :label="translations.max[lang]"
          type="number"
          v-model="limits.max_amount_limit"
          @blur="validate"
        ></b-text-field>
      </v-col>
    </v-row>
  </b-standard-card>
</template>

<script>
import translations from '@/utils/translations/storePanel/settings/profile/transactionLimit';
import { mapState, mapMutations, mapActions } from 'vuex';

export default {
  name: 'TransactionLimit',

  mixins: [translations],

  computed: {
    lang() {
      return this.$route.params.lang;
    },
    loading() {
      return this.$store.state.storePanel.profile.loading.store_settings;
    },
    storeMode() {
      return this.$store.state.store?.display_mode || 'points';
    },
    errorMessage: {
      get() {
        return this.$store.state.storePanel.profile.errorMessage.store_settings;
      },
      set(val) {
        this.$store.state.storePanel.profile.errorMessage.store_settings = val;
      },
    },
    resetSuccess() {
      return this.$store.state.storePanel.profile.resetSuccess.store_settings;
    },

    ...mapState('storePanel', ['store']),

    limits: {
      get() {
        return {
          min_amount_limit: Number(this.store?.store_settings?.min_amount_limit) || null,
          max_amount_limit: Number(this.store?.store_settings?.max_amount_limit) || null,
        };
      },
      set(val) {
        this.store.store_settings = {
          min_amount_limit: Number(val?.min_amount_limit) || null,
          max_amount_limit: Number(val?.max_amount_limit) || null,
        };
        this.setStore(this.store);
      },
    },
  },
  methods: {
    ...mapActions('storePanel/profile', ['updateTransactionLimit']),
    ...mapMutations('storePanel', ['setStore']),
    validate() {
      this.errorMessage = '';
      let maxLimit = Number(this.limits.max_amount_limit || 0);
      let minLimit = Number(this.limits.min_amount_limit || 0);
      if (isNaN(maxLimit) || isNaN(minLimit)) {
        return false;
      }
      if (!maxLimit || !minLimit) {
        return true;
      }
      if (maxLimit < 0 || minLimit < 0) {
        this.errorMessage = this.translations.negativeAmountError[this.lang];
      } else if (maxLimit <= minLimit) {
        this.errorMessage = this.translations.maxMinError[this.lang];
      }
      return !this.errorMessage;
    },

    submitData() {
      if (this.validate()) {
        this.updateTransactionLimit({ type: 'store_settings', body: this.limits });
      }
    },
  },
};
</script>
